import React, { useState } from 'react';

const Eligibility = ({ onNext, answers, stepKey }) => {
  const [showSorryModal, setShowSorryModal] = useState(false);
  const [clickedButton, setClickedButton] = useState(null);

  const handleClick = (e) => {
    const buttonValue = e.target.value;
    setClickedButton(buttonValue);
    
    if (buttonValue == '392') {
      setShowSorryModal(true);
    } else {
      onNext(buttonValue);
    }
  };

  const handleCloseModal = () => {
    setShowSorryModal(false);
  };

  const hasAnswered = answers && answers[stepKey];

  return (
    <>
      <div className="qs-card__head"><h2 className="qs-card__title">Eligibility</h2></div>
      {!hasAnswered && (
        <div className="qs-card__body">
          <p className="qs-card__sub">Have you, or any company acting on your behalf, ever previously submitted a complaint to the credit card provider?</p>
          <div className="qs-actions">
            <button 
                value={392}
               type="button" 
               className={`qs-btn qs-btn--optn ${clickedButton == '392' ? 'btn-active' : ''}`} 
               data-ans-id={392}
               onClick={handleClick}>
                 Yes
             </button>
            <button 
              type="button" 
              value={393}
              className={`qs-btn qs-btn--optn ${clickedButton == '393' ? 'btn-active' : ''}`} 
              data-ans-id={393}
              onClick={handleClick}>
                No</button>

          </div>
        </div>
      )}

      {showSorryModal && (
        <div className="qs-modal is-open" id="sorryModal" aria-hidden="false">
          <div className="qs-modal__backdrop" onClick={handleCloseModal}></div>
          <div className="qs-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="sorryTitle">
            <button className="qs-modal__close" onClick={handleCloseModal} aria-label="Close">
              <i className="bi bi-x-lg"></i>
            </button>
            <div className="qs-modal__body">
              <div className="qs-emoji">🥺</div>
              <h3 id="sorryTitle" className="qs-modal__title">
                <span className="qs-text-danger">Sorry,</span> We are unable to assist as you have already tried to claim.
              </h3>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Eligibility;
